import React, { useContext, useEffect, useState } from "react";
import "./styles.css";
import { Header, HomeProfileSection } from "components";
import Home from "pages/home";
import { routePaths } from "routes";
import { getProfile } from "utilities";
import { ApplicationContext } from "shared";

// Feature flag — hide the Insurance area until it's ready to launch.
const INSURANCE_ENABLED = process.env.REACT_APP_INSURANCE_ENABLED === "true";

const Dashboard = ({ subComponent: ChildComponent, selectedId }) => {
  const {getTheUpdatedData} = useContext(ApplicationContext);
  const [navMenuList, setNavMenuList] = useState([
    {
      id: 1,
      name: `Home`,
      navigationScreen: routePaths.home,
      isSelected: true,
    },
    {
      id: 2,
      name: `Manage Account`,
      navigationScreen: routePaths.manageAccount,
      isSelected: false,
    },
    {
      id: 3,
      name: `Locations`,
      navigationScreen: routePaths.locations,
      isSelected: false,
    },
    ...(INSURANCE_ENABLED
      ? [{
          id: 4,
          name: `Insurance`,
          navigationScreen: routePaths.insurance,
          isSelected: false,
        }]
      : []),
  ]);

  useEffect(() => {
    getTheUpdatedData();
  },[])

  useEffect(() => {
    const tempArray = [];
    console.log("test");
    navMenuList.map((item) => {
      tempArray.push({
        ...item,
        isSelected: item.id == selectedId,
      });
    });
    setNavMenuList(tempArray);
  }, [selectedId]);

  return (
    <div className="container" style={{overflowX: 'hidden'}}>
      <Header navMenuList={navMenuList} />
      <ChildComponent />
    </div>
  );
};

export default Dashboard;
